export const imageLinks = {
  LOGO_BLUE: "https://assets.alpharun.com/alpharun.png",
  LOGO_WHITE: "https://assets.alpharun.com/alpharun_white.png",
};
